import React, { memo } from 'react';

const Blogs = memo(() => (
  <div>
    <div className='black font-16px medium mb-md-3 mb-2'>More</div>
    <div className='d-flex d-md-block'>
      <div className='font-14px m-b-10'>
        <a className='gray' href='https://blogs.awign.com' rel='noopener noreferrer' target='_blank'>
          Blogs
        </a>
      </div>
      <div className='font-14px m-b-10 ml-md-0 ml-4'>
        <a className='gray' href='https://awign.com/privacy_policy' rel='noopener noreferrer' target='_blank'>
          Privacy Policy
        </a>
      </div>
      <div className='font-14px m-b-10 ml-md-0 ml-4'>
        <a className='gray' href='https://awign.com/terms_and_conditions' rel='noopener noreferrer' target='_blank'>
          Terms & Conditions
        </a>
      </div>
    </div>
  </div>
));

Blogs.displayName = 'Blogs';

export default Blogs;
